// extracted by mini-css-extract-plugin
export default {"loader":"BtnLoader_loader__f4xlm","rotation":"BtnLoader_rotation__j56x5"};